export const SPORTSBOOK_GAMING_HISTORY = 'sportsbook-gaming-history';

export const DEFAULT_PAGE_SIZE = 30;
export const EXPORT_PAGE_SIZE = 100;

export const ONE_MONTH_VALUE = 1;

export const LAST_24_HOURS_VALUE = 1;
export const LAST_WEEK_VALUE = 7;
export const LAST_MONTH_VALUE = 30;
export const LAST_THREE_MONTHS_VALUE = 90;
export const LAST_SIX_MONTHS_VALUE = 180;
export const ANOTHER_PERIOD_VALUE = -1;
